import { Col, Row } from "react-bootstrap";
import DateField from "../../../../../layout/Form/Fields/DateField";
import SelectField from "../../../../../layout/Form/Fields/SelectField";
import TextField from "../../../../../layout/Form/Fields/TextField";
import ActionTags from "./ActionTags";
import MDEditor from "@uiw/react-md-editor";

const ActionBasics = ({ formik, allTags, setAllTags }) => {
  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col>
              <TextField
                formik={formik}
                label={"Title"}
                valueName={"title"}
                style={{ marginBottom: "10px" }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <DateField
                formik={formik}
                label={"Start"}
                valueName={"start"}
                style={{ marginBottom: "10px" }}
              />
            </Col>
            <Col>
              <DateField
                formik={formik}
                label={"End"}
                valueName={"ende"}
                style={{ marginBottom: "10px" }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DateField
                formik={formik}
                label={"Deadline"}
                valueName={"deadline"}
                style={{ marginBottom: "10px" }}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <SelectField
                formik={formik}
                label={"Priority"}
                valueName={"priority"}
                style={{ marginBottom: "10px" }}
              >
                <option></option>
                <option value="Highest">Highest</option>
                <option value="High">High</option>
                <option value="Normal">Normal</option>
                <option value="Low">Low</option>
                <option value="Nicetohave">Nice to have</option>
              </SelectField>
            </Col>
            <Col>
              <SelectField
                formik={formik}
                label={"Status"}
                valueName={"status"}
                style={{ marginBottom: "10px" }}
              >
                <option></option>
                <option value="Backlog">Backlog</option>
                <option value="Created">Created</option>
                <option value="In_Progress">In Progress</option>
                <option value="Waiting">Waiting</option>
                <option value="On_Hold">On Hold</option>
                <option value="Done">Done</option>
                <option value="Canceled">Canceled</option>
              </SelectField>
            </Col>
          </Row>
        </Col>
      </Row>
      <ActionTags allTags={allTags} setAllTags={setAllTags} formik={formik} />
      <br />
      <Row>
        <Col>
          <label style={{ fontSize: "0.72rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "6px", display: "block" }}>
            Description
          </label>
          <div data-color-mode="light">
            <MDEditor
              value={formik.values.beschreibung || ""}
              onChange={(val) => formik.setFieldValue("beschreibung", val || "")}
              height={300}
              preview="edit"
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ActionBasics;
